<app-icon [name]="currencyIcon$ | async" [size]="size"></app-icon>
